import { authService } from "../authServices";
import { CONFIG } from "../config";

export class ApiError extends Error {
  statusCode: number;

  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
    this.name = 'ApiError';
  }
}

export class ModuleError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ModuleError';
  }
}

// Global error handler
export const handleError = (error: unknown): void => {
  if (error instanceof ApiError) {
    console.error(`API Error: ${error.message} (Status: ${error.statusCode})`);

    // Let the calling function decide how to handle unauthorized errors
    if (error.statusCode === 401) {
      console.warn('Unauthorized access detected.');
      authService.clearToken();
      CONFIG.urls.getLogoutUrl();
    }

  } else if (error instanceof ModuleError) {
    console.error(`Module Error: ${error.message}`);
  } else if (error instanceof Error) {
    console.error(`General Error: ${error.message}`);
  } else {
    console.error('Unknown error occurred:', error);
  }
};

// Unauthorized error handling logic
export const handleUnauthorizedError = (
  setErrorMessage: (message: string) => void,
  serverMessage?: string // Optional server-provided message
) => {
  authService.clearToken();
  setErrorMessage(serverMessage || 'Your session has expired. Please log in again.');
};
